import { render, staticRenderFns } from "./ProcessCharacteristicDetailCard.vue?vue&type=template&id=6e8fdcd2&scoped=true"
import script from "./ProcessCharacteristicDetailCard.vue?vue&type=script&lang=js"
export * from "./ProcessCharacteristicDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ProcessCharacteristicDetailCard.vue?vue&type=style&index=0&id=6e8fdcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8fdcd2",
  null
  
)

export default component.exports